module.exports = __webpack_public_path__ + "img/face.ea30713b.svg";